import * as React from "react";

const CopyIcon = (props) => (
  <svg
    width={17}
    height={17}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.3635 10.0886H2.69082C2.33401 10.0886 1.99181 9.94685 1.73951 9.69455C1.4872 9.44224 1.34546 9.10005 1.34546 8.74323V2.68911C1.34546 2.3323 1.4872 1.9901 1.73951 1.7378C1.99181 1.48549 2.33401 1.34375 2.69082 1.34375H8.74494C9.10176 1.34375 9.44395 1.48549 9.69626 1.7378C9.94856 1.9901 10.0903 2.3323 10.0903 2.68911V3.36179M7.39958 6.05251H13.4537C14.1967 6.05251 14.7991 6.65485 14.7991 7.39787V13.452C14.7991 14.195 14.1967 14.7974 13.4537 14.7974H7.39958C6.65656 14.7974 6.05422 14.195 6.05422 13.452V7.39787C6.05422 6.65485 6.65656 6.05251 7.39958 6.05251Z"
      stroke={props?.color ?? "#8b58f1"}
      strokeWidth={1.34536}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default CopyIcon;
